import { storeService } from '@/services';
import StoreVM from '@/view-model/store-management/StoreVM';
export default {
    resetStoreDetail({ commit }) {
        commit('RESET_STORE_DETAIL');
    },
    async getStoreDetail({ commit }, storeId) {
        const response = await storeService.getStoreDetail(storeId);
        const res = new StoreVM(response.data);
        commit('GET_STORE_DETAIL', res);
    },
    async editStoreBasicInfo(_, data) {
        try {
            await storeService.editStoreBasicInfo(data);
            return {
                isSuccess: true,
            };
        }
        catch (error) {
            const message = error.response?.data.error.message ?? error.message;
            const reason = error.response?.data.error.reason ?? error.reason;
            return {
                isSuccess: false,
                reason,
                message,
            };
        }
    },
};
